export const RESET_QUIZ = "RESET_QUIZ";

export const AUTOLOGIN = "AUTOLOGIN";

export const AutoLogin = (data) => {
  console.log("data", data);
  return {
    type: 'AUTOLOGIN',
    payload: data,
  };
};
export const resetQuiz = () => ({
  type: RESET_QUIZ,
});

